<template>
  <el-button
    v-bind="$attrs"
    v-on="$listeners"
    :type="type"
    :size="size"
    :loading="loading"
    :disabled="disabled"
    :round="round"
    :circle="circle"
    :icon="icon"
  >
    <slot>{{ text }}</slot>
  </el-button>
</template>

<script>
  export default {
    name: 'SgpButton',

    props: {
      type: {
        type: String,
        default: 'default'
      },
      size: {
        type: String,
        default: 'medium'
      },
      loading: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      round: {
        type: Boolean,
        default: false
      },
      circle: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: ''
      }
    }
  }
</script>
